export default __webpack_public_path__ + "/dist/images/faq_image.a2afe6b2695f778f8a20f90c6995fb22.png";